module.exports = __webpack_public_path__ + "img/ic-muscle.255a397c.svg";